import {requests} from '../../utils/api.service';
import {ONBOARDING_URL} from '../../utils/Endpoints';

export const OnboardingService = {
    getAllRequests: (params: any) => requests.get(`${ONBOARDING_URL}/requested`, params),
    updateIsContacted:(id: number) => requests.put(`${ONBOARDING_URL}/requests/contact/toggle/${id}`, {}),
}
